/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Opos_AccountsInputs */



/**

* @param {_Opos_AccountsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _opos_accounts = /** @type {((inputs?: _Opos_AccountsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Opos_AccountsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Debitorennummern")
});